import React, { useEffect, useState } from 'react'
import { Box, Button, Checkbox, CircularProgress, Divider, FormControlLabel, Grid, TextField, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { AwardIcon } from 'lucide-react';
import { toast } from 'react-toastify';
import apiClient from '../../utils/apiClient';

import {
  //   Grid,
  //   TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  //   Checkbox,
  ListItemText,
} from "@mui/material";

const AddEditRoles = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const roles = location?.state?.role || '';
  const [formData, setFormData] = useState({
    id: '', name: "", isActive: false, isDeleted: false,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    if (roles) {
      setFormData(roles);
    }
  }, [roles])
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let response;
      // if (roles?.id) {
      //   response = await axios.put(apiUrl + `/role/updaterole/${roles?.id}`, formData);
      // }
      // else {
      //   response = await axios.post(apiUrl + `/role/role`, formData);
      // }
      if (roles?.id) {
        response = await apiClient.put(`/role/updaterole/${roles?.id}`, formData);
      } else {
        response = await apiClient.post('/role/role', formData);
      }
      if (response?.data?.status === true) {
        toast.success(response?.data?.message || "Role create / edit successfull")
        navigate(-1)
      }

    } catch (error) {
      setError(error?.response?.data?.message || 'Error create / edit role');
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Box sx={{ p: { xs: 2, sm: 2 } }}>
        <Typography variant="h4" fontWeight={400} mb={1} >
          {roles ? `Edit Role - ${formData.name}` : 'Add New Role'}

        </Typography>
        <Divider sx={{ mb: 3 }} />
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2} sx={{ maxWidth: 500, border: '1px solid lightgrey', borderRadius: 1, p: 2 }}>
            <Grid item size={{ xs: 12, sm: 12 }}>
              <TextField
                label="name"
                name="name"
                fullWidth
                size="small"
                value={formData.name}
                onChange={handleInputChange}
              />
            </Grid>
            {/* Checkboxes */}
            <Grid item size={{ xs: 12, sm: 12 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="isActive"
                    checked={formData.isActive}
                    onChange={handleCheckboxChange}
                    size="small"
                  />
                }
                label="Is Active"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="isDeleted"
                    checked={formData.isDeleted}
                    onChange={handleCheckboxChange}
                    size="small"
                  />
                }
                label="Is Deleted"
              />
            </Grid>
            {error &&
              <Typography variant='body2' color='error'>{error}</Typography>
            }
            <Grid item size={12}>
              <Box display="flex" justifyContent="end" mt={2} gap={2}>
                <Button variant="outlined" color="primary" onClick={() => navigate(-1)}>
                  Cancel
                </Button>
                <Button type="submit" variant="contained" disabled={loading}>
                  {loading ? (
                    <CircularProgress size={24} sx={{ color: '#fff' }} />
                  ) : (
                    roles ? 'Update' : 'Create'
                  )}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>

      </Box>
    </>
  )
}

export default AddEditRoles
